<template>
    <fragment >
		
        <template v-if="item.children">
                   <el-submenu v-if="!(item.path&&item.path!='-')"  :index="item.id.toString()"  >
                       <template slot="title" >
                           <i v-if="item.icon" :class="item.icon"></i>
                           <span slot="title">{{item.name}}</span>
                       </template>
                       <template v-for="items in item.children">
                           <!-- 这里实现自己递归嵌套 -->
                           <template v-if="!items.hidden">
                               <appMenu
                                       v-if="items.children&&items.children.length>0"
                                       :item="items"
                                       :index="items.id"
                                       :key="items.id"/>
                               <el-menu-item v-else :index="items.path+items.params" @click="menuClick(items)">
                                   <i  :class="items.icon"></i>
                                  {{items.name}}
                               </el-menu-item>
                           </template> 
                       </template>
                   </el-submenu>
                   <template v-else>
                       <el-menu-item :index="item.id.toString()"  @click="menuClick(item)">
                           <i  :class="item.icon"></i>
                            <span slot="title" >{{item.name}}</span>
                       </el-menu-item>
                   </template>
               </template>
               <!-- 没有子节点，直接输出 -->
              <template v-else-if="item.name!='首页'">
                   <el-menu-item :index="item.path+item.params"  @click="menuClick(item)" >
                       <i :class="item.icon"></i>
                           <span   slot="title">{{item.name}}</span>
                   </el-menu-item>
               </template>
			   
    </fragment>
</template>

<script>
    export default {
		 name: "appMenu",
         data() {
    return {
    };
  },
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        computed:{
     stateLanguage(){
       return this.$store.state.language;
     }},
        methods: {
            menuClick: function (e) {
				if(this.$store.state.menu.name==e.name)e.isLock=true;
			this.$store.commit("saveMenu", e);
				this.$store.commit("saveOperate", "");
				 //  this.$store.commit("saveOperate", "");
            }
        }

    }
</script>
